import React, { useState } from 'react';
import { ThreeDots } from "react-loader-spinner";
import Select from "react-select";
import { updateArtWorks } from "../../Api/apiUrls";

const Update_Art_Work = ({ artwork, onClose, onArtworkUpdated }) => {
  const [formData, setFormData] = useState({
    title: artwork.name || '',
    description: artwork.description || '', // Added description field
    rate: artwork.price || '',
    sequence: artwork.sequence || '',
    status: artwork.status_code?.toString() || '0',
    photo: []
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [newPreview, setNewPreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'rate' || name === 'sequence') {
      if (/^\d*$/.test(value)) {
        setFormData({
          ...formData,
          [name]: value
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleStatusChange = (selectedOption) => {
    setFormData({
      ...formData,
      status: selectedOption.value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        photo: [file]
      });
      
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setIsSubmitting(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("art_work_id", artwork.id);
      formDataToSend.append("title", formData.title);
      formDataToSend.append("description", formData.description || ""); // Added description
      formDataToSend.append("rate", formData.rate || "0");
      formDataToSend.append("sequence", formData.sequence || "0");
      formDataToSend.append("status", formData.status);

      // Append new photo if selected
      if (formData.photo.length > 0) {
        formDataToSend.append("photo", formData.photo[0]);
      }

      const response = await fetch(updateArtWorks, {
        method: "PUT",
        body: formDataToSend,
      });

      if (!response.ok) {
        throw new Error("Failed to update artwork");
      }

      const data = await response.json();
      
      if (data.success) {
        alert("Artwork updated successfully!");
        if (onArtworkUpdated) onArtworkUpdated();
        onClose();
      } else {
        alert(data.message || "Failed to update artwork");
      }
    } catch (error) {
      console.error("Error updating artwork:", error);
      alert("Error updating artwork. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const StatusOptions = [
    { value: "0", label: "Pending" },
    { value: "1", label: "Approve" },
    { value: "-1", label: "Reject" },
  ];

  const handleClick = (e) => {
    if (e.currentTarget === e.target) {
      onClose();
    }
  };

  return (
    <div className="popup-background" onClick={handleClick}>
      <div className="popup" style={{ maxWidth: "600px", maxHeight: "90vh" }}>
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Update Artwork</h5>
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              {/* Current Image */}
              <div className="form-group mb-3">
                <label className="small mb-1">Current Image</label>
                {artwork.image ? (
                  <div className="text-center">
                    <img
                      src={artwork.image}
                      alt={artwork.name}
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "5px",
                        border: "1px solid #ddd"
                      }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = "https://via.placeholder.com/150x150?text=No+Image";
                      }}
                    />
                    <p className="text-muted mt-1">
                      <small>Current image</small>
                    </p>
                  </div>
                ) : (
                  <p className="text-muted">No image available</p>
                )}
              </div>

              {/* New Image Upload
              <div className="form-group mb-3">
                <label className="small mb-1">New Image (Optional)</label>
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={handleFileChange}
                />
                <small className="text-muted">Leave empty to keep current image</small>
                
                {newPreview && (
                  <div className="mt-2">
                    <label className="small mb-1">New Image Preview:</label>
                    <img
                      src={newPreview}
                      alt="New preview"
                      style={{
                        width: "150px",
                        height: "150px",
                        objectFit: "cover",
                        borderRadius: "5px",
                        border: "1px solid #ddd"
                      }}
                    />
                  </div>
                )}
              </div> */}

              {/* Title */}
              <div className="form-group mb-3">
                <label className="small mb-1">Title *</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  placeholder="Enter artwork title"
                  required
                />
              </div>

              {/* Description - New Field */}
              <div className="form-group mb-3">
                <label className="small mb-1">Description (Optional)</label>
                <textarea
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  placeholder="Enter artwork description"
                  rows="3"
                />
              </div>

              {/* Rate */}
              <div className="form-group mb-3">
                <label className="small mb-1">Rate</label>
                <input
                  type="text"
                  className="form-control"
                  name="rate"
                  value={formData.rate}
                  onChange={handleInputChange}
                  placeholder="Enter rate"
                  inputMode="numeric"
                />
              </div>

              {/* Sequence */}
              <div className="form-group mb-3">
                <label className="small mb-1">Sequence</label>
                <input
                  type="text"
                  className="form-control"
                  name="sequence"
                  value={formData.sequence}
                  onChange={handleInputChange}
                  placeholder="Enter sequence"
                  inputMode="numeric"
                />
              </div>

              {/* Status */}
              <div className="form-group mb-3">
                <label className="small mb-1">Status</label>
                <Select
                  options={StatusOptions}
                  value={StatusOptions.find(opt => opt.value === formData.status)}
                  onChange={handleStatusChange}
                  placeholder="Select status"
                />
              </div>

              {/* Buttons */}
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={onClose}
                  disabled={isSubmitting}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <ThreeDots color="#fff" height={20} width={20} />
                      <span className="ms-2">Updating...</span>
                    </>
                  ) : (
                    'Update Artwork'
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Update_Art_Work;